import PropTypes from "prop-types";
import React from "react";

const Button = ({ isIcon, icon, buttonText, buttonType, className, onClick }) => {
  return (
    <button type={buttonType} className={`btn ${className}`} onClick={onClick}>
      {isIcon && (
        <span className="glyphicon">
          <i className={icon} aria-hidden="true"></i>
        </span>
      )}
      <b>{buttonText}</b>
    </button>
  );
};

Button.propTypes = {
  isIcon: PropTypes.bool,
  icon: PropTypes.string,
  buttonText: PropTypes.string.isRequired,
  buttonType: PropTypes.oneOf(["button", "submit", "reset"]),
  className: PropTypes.string,
};

export default Button;
